// import Spin from "antd/lib/spin";
import { getCloudToken } from "api/authAPI";
import {
  CloudTokenResponse,
  NVRTokenResponse,
  NvrLinkTokenResponse,
} from "api/interfaces/authInterface.interface";
import {
  getNvrLinkToken,
  getPfToken,
  postLocalConnectCreate,
  // postLocalConnectTest,
} from "api/recorderAPI";
import { UnderlineText } from "components/atoms/text/Text";
import { SpectrumLogin } from "pages/auth/signin/cloud/SpectrumLogin";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useAppSelector } from "redux/hooks";
import styled from "styled-components";
import { COLORS } from "styles/colors";
import { FLEX } from "styles/flex";
import { setupAppLauncher, setupWebLauncher } from "utils/RecorderUtil";
import SpectrumLoginConfirmModal from "./confirm";
// import { isEmpty } from "lodash";
import { useMutation } from "react-query";
import {
  CustomError,
  LEVEL_TYPE,
} from "api/interfaces/commonInterface.interface";
import useApiError from "hook/useApiError";
import {
  LocalConnectionInfo,
  LocalConnectionInfoResponse,
} from "api/interfaces/recorderInterface.interface";
import { convertType, getClientDevice } from "utils/functions";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { useAuth } from "components/Auth";
// import { RecorderType } from "components/atoms/text/labels/Type";
import { FaLink } from "react-icons/fa6";
import { WithTooltip } from "../WithTooltip";
import { calcRem } from "styles/theme";
import SmallPopupTemplate from "components/templates/modal/small/SmallPopupTemplate";

interface LinkProps {
  type: string;
  accountId: string;
  recorderId: string;
  mergedSystemId: string;
  cloudSystemId?: string;
  brand?: string;
  displayType?: string;
  cloudStatus?: boolean; // dw 접속상태
  isCovaConfigure?: boolean;
  isRestricted?: boolean;
}

function WebAppLink(props: LinkProps): JSX.Element {
  const cloudStatus =
    props.cloudStatus === undefined ? true : props.cloudStatus;
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  // const theme = useAppSelector((state) => state.theme.theme);
  const { notifyInfo, lang, handleErrorNotify } = useApiError();
  const { user } = useAuth();
  const [showRestrictedPopup, setShowRestrictedPopup] =
    useState<boolean>(false);

  const [selectLinkType, setSelectLinkType] = useState<string>("web");

  const [isOpenSpectrumLogin, setIsOpenSpectrumLogin] =
    useState<boolean>(false);
  const [isLocalSpectrumLogin, setIsLocalSpectrumLogin] =
    useState<boolean>(false);
  const [isIos, setIsIos] = useState(false);
  const [isAndroid, setIsAndroid] = useState(false);

  useEffect(() => {
    const isIOS =
      navigator.userAgent.match(/iPhone|iPad|iPod/i) === null &&
      navigator.maxTouchPoints !== 5
        ? false
        : true;
    setIsIos(isIOS);
    setIsAndroid(
      window.navigator.userAgent.toLowerCase().indexOf("android") > -1
    );
  }, []);

  const isRestricted = useMemo(() => {
    return (
      props.isRestricted ||
      (selectedAccount.restrictList || []).some(
        (item) => item.mergedSystemId === props.mergedSystemId
      )
    );
  }, [props.isRestricted, props.mergedSystemId, selectedAccount.restrictList]);

  const onToggleRestrictedPopup = useCallback(() => {
    setShowRestrictedPopup(!showRestrictedPopup);
  }, [showRestrictedPopup]);

  const OnClickWebLink = useCallback(() => {
    if (isRestricted) {
      onToggleRestrictedPopup();
      return;
    }
    setSelectLinkType("web");
    try {
      if (props.type !== undefined && props.type.toUpperCase() === "SPECTRUM") {
        if (props.cloudSystemId) {
          getCloudToken({
            accountId: props.accountId,
            mergedSystemId: props.mergedSystemId as string,
          })
            .then((res: CloudTokenResponse) => {
              if (res.error !== 0) {
                notifyInfo(lang.label.link.notify.token.error);
                return;
              }

              if (
                res.result.token === undefined ||
                res.result.token === "" ||
                res.result.token === null
              ) {
                setIsOpenSpectrumLogin(true);
                // notify(
                //   "info",
                //   intl.formatMessage({
                //     id: "label.link.notify.token.error",
                //     defaultMessage: "Fail to find your connection information.",
                //   })
                // );
                return;
              } else {
                const linkWindow = window.open(
                  `https://dwspectrum.digital-watchdog.com`,
                  `_blank`
                );
                setupWebLauncher(
                  props.type,
                  // sessionStorage.getItem("code") as string
                  res.result.token,
                  props.cloudSystemId,
                  linkWindow
                );
              }
            })
            .catch((err: CustomError) => {
              //setIsOpenSpectrumLogin(true);
              handleErrorNotify(err, lang.label.link.notify.token.error);
              // notify(
              //   "error",
              //   intl.formatMessage({
              //     id: "label.link.notify.token.error",
              //     defaultMessage: "Fail to find your connection information.",
              //   })
              // );
            });
        }
        //  else {
        //   const linkWindow = window.open(``, `_blank`);
        //   linkWindow?.blur();
        //   window.focus();
        //   getLocalSpectrumWebLinkToken({
        //     accountId: props.accountId,
        //     mergedSystemId: props.mergedSystemId as string,
        //   })
        //     .then((res: LocalConnectionInfoResponse) => {
        //       if (res.error !== 0) {
        //         linkWindow?.close();
        //         window.focus();
        //         notifyInfo(lang.label.link.notify.token.error);
        //         return;
        //       }

        //       if (
        //         res.result.token === undefined ||
        //         res.result.token === "" ||
        //         res.result.token === null
        //       ) {
        //         setIsLocalSpectrumLogin(true);
        //         linkWindow?.close();
        //         window.focus();
        //         // notify(
        //         //   "info",
        //         //   intl.formatMessage({
        //         //     id: "label.link.notify.token.error",
        //         //     defaultMessage: "Fail to find your connection information.",
        //         //   })
        //         // );
        //       } else {
        //         if (linkWindow !== null) {
        //           linkWindow.location.href = `https://${res.result.host}:${res.result.port}/static/index.html#/?token=${res.result.token}`;
        //         } else {
        //         }
        //         // window.open(
        //         //   `https://${res.result.host}:${res.result.port}/static/index.html#/?token=${res.result.token}`,
        //         //   "_blank",
        //         //   "noreferrer"
        //         // );
        //       }
        //     })
        //     .catch(() => {
        //       setIsLocalSpectrumLogin(true);
        //       linkWindow?.close();
        //       window.focus();
        //       notifyInfo(lang.label.link.notify.token.error);
        //     });
        // }
      } else {
        //NVR
        let pfLinkUrl = `https://pf.mydw.cloud`;
        if (
          props.brand === "tvt" &&
          process.env.REACT_APP_DATADOG_ENV === "development"
        ) {
          pfLinkUrl = `https://testpf.mydw.cloud`;
        }
        getPfToken({
          accountId: props.accountId,
          recorderId: props.recorderId,
        })
          .then((res: NVRTokenResponse) => {
            if (res.error !== 0 || res.result === undefined) {
              notifyInfo(lang.label.link.notify.token.error);
              return;
            }
            const linkWindow = window.open(pfLinkUrl, `_blank`);
            setupWebLauncher(
              props.type,
              // sessionStorage.getItem("code") as string
              res.result,
              props.recorderId,
              linkWindow,
              props.brand
            );
          })
          .catch(() => {
            notifyInfo(lang.label.link.notify.token.error);
          });
      }
    } catch {}
  }, [
    isRestricted,
    onToggleRestrictedPopup,
    props.type,
    props.cloudSystemId,
    props.accountId,
    props.mergedSystemId,
    props.brand,
    props.recorderId,
    notifyInfo,
    lang.label.link.notify.token.error,
    handleErrorNotify,
  ]);

  const OnClickAppLink = useCallback(() => {
    if (isRestricted) {
      onToggleRestrictedPopup();
      return;
    }
    setSelectLinkType("app");
    try {
      if (props.type !== undefined && props.type.toUpperCase() === "SPECTRUM") {
        if (!props.cloudSystemId) {
          setupAppLauncher(props.type, "", "");
          return;
        }
        // if (props.cloudSystemId) {
        getCloudToken({
          accountId: props.accountId,
          mergedSystemId: props.mergedSystemId as string,
        })
          .then((res: any) => {
            if (
              res.error !== 0 ||
              res.result.token === undefined ||
              res.result.token === "" ||
              res.result.token === null ||
              props.type === undefined ||
              props.cloudSystemId === undefined
            ) {
              setIsOpenSpectrumLogin(true);
              return;
            }
            setupAppLauncher(props.type, props.cloudSystemId, res.result.token);
          })
          .catch(() => {
            setIsOpenSpectrumLogin(true);
          });
        // } else {
        // getLocalSpectrumAppLinkToken({
        //   accountId: props.accountId,
        //   mergedSystemId: props.mergedSystemId as string,
        // })
        //   .then((res: LocalConnectionInfoResponse) => {
        //     if (
        //       res.error !== 0 ||
        //       res.result.auth === undefined ||
        //       res.result.token === undefined ||
        //       res.result.token === "" ||
        //       res.result.token === null
        //     ) {
        //       setAppLoading(false);
        //       notifyInfo(
        //         lang.label.recorder.notify.connectionTest.registration
        //       );
        //       setIsLocalSpectrumLogin(true);
        //       return;
        //     }
        //     setupAppLauncher(
        //       props.type,
        //       "",
        //       // sessionStorage.getItem("code") as string
        //       res.result.token,
        //       res.result.host,
        //       res.result.port
        //     );
        //   })
        //   .catch(() => {
        //     setIsLocalSpectrumLogin(true);
        //   });
        // }
      } else {
        //"dw-c3cms://c3cms.digital-watchdog.com/client?ip=P2P-A50F81F4B6BA-201FF5&mac=a8:dc:5a:20:1f:f5&p2p=1&cammax=12&auth=YWRtaW46ZElnSXRBTHdBVENIZE9HOkFkbWluMTIzNCE="
        getNvrLinkToken({
          accountId: props.accountId,
          recorderId: props.recorderId,
        }).then((res: NvrLinkTokenResponse) => {
          setupAppLauncher(
            props.type,
            props.cloudSystemId !== undefined ? props.cloudSystemId : "",
            res.result.auth,
            res.result.ip,
            undefined,
            res.result.mac,
            res.result.p2p,
            res.result.camMax,
            props.displayType,
            user.email
          );
        });
      }
    } catch {}
  }, [props.type, props.cloudSystemId, props.mergedSystemId]);

  const onCloseWebLogin = () => {
    setIsOpenSpectrumLogin(false);
  };

  const onCloseLocalLogin = () => {
    setIsLocalSpectrumLogin(false);
  };

  // const mutationSpectrumConnection = useMutation(postLocalConnectCreate, {
  //   onSuccess: (res: LocalConnectionInfoResponse) => {
  //     if (
  //       res.result.token !== undefined &&
  //       res.result.token !== "" &&
  //       res.result.token !== null &&
  //       props.cloudSystemId !== undefined
  //     ) {
  //       if (selectLinkType === "web") {
  //         setupWebLauncher(
  //           props.type,
  //           // sessionStorage.getItem("code") as string
  //           res.result.token,
  //           props.cloudSystemId
  //         );
  //       } else if (selectLinkType === "app") {
  //         setupAppLauncher(
  //           props.type,
  //           props.cloudSystemId,
  //           // sessionStorage.getItem("code") as string
  //           res.result.token
  //         );
  //       }
  //     } else {
  //       notify(
  //         "error",
  //         intl.formatMessage({
  //           id: "label.recorder.notify.connectionTest.fail",
  //           defaultMessage: "The connection test failed.",
  //         })
  //       );
  //     }
  //   },
  //   onError: (err: CustomError) => {
  //     handleError(
  //       err,
  //       intl.formatMessage({
  //         id: "label.recorder.notify.connectionTest.fail",
  //         defaultMessage: "The connection test failed.",
  //       })
  //     );
  //   },
  // });
  const onCode = useCallback(() => {
    setIsOpenSpectrumLogin(false);
    if (selectLinkType === "web") {
      OnClickWebLink();
    } else if (selectLinkType === "app") {
      OnClickAppLink();
    } else {
    }
  }, [OnClickAppLink, OnClickWebLink, selectLinkType]);
  // const onCode = useCallback(
  //   (code: string, params: URLSearchParams) => {
  //     if (!isEmpty(code)) {
  //       setIsOpenSpectrumLogin(false);
  //       window.open("", "_newWin"+ props.cloudSystemId);
  //       if (selectLinkType === "web") {
  //         if (props.cloudSystemId) {
  //           mutationSpectrumConnection.mutate({
  //             accountId: props.accountId,
  //             mergedSystemId: props.mergedSystemId,
  //             payload: { code: code },
  //           });
  //         }
  //       } else if (selectLinkType === "app") {
  //         if (props.cloudSystemId) {
  //           mutationSpectrumConnection.mutate({
  //             accountId: props.accountId,
  //             mergedSystemId: props.mergedSystemId,
  //             payload: { code: code },
  //           });
  //         }
  //       }
  //     } else {
  //     }
  //   },
  //   [
  //     mutationSpectrumConnection,
  //     props.accountId,
  //     props.cloudSystemId,
  //     props.mergedSystemId,
  //     selectLinkType,
  //   ]
  // );

  const mutationConnectionCreate = useMutation(postLocalConnectCreate, {
    onSuccess: (res: LocalConnectionInfoResponse) => {
      setIsLocalSpectrumLogin(false);
      if (selectLinkType === "web") {
        OnClickWebLink();
      } else {
        OnClickAppLink();
      }

      // if (res.result.token !== undefined) {
      //   window.open(
      //     `https://${res.result.host}:${res.result.port}/static/index.html#/?token=${res.result.token}`,
      //     "_blank",
      //     "noreferrer"
      //   );
      // } else {
      // }
      // notify(
      //   "success",
      //   intl.formatMessage({
      //     id: "label.common.notify.email.success",
      //     defaultMessage: "Email sent successfully",
      //   })
      // );
    },
    onError: (err: CustomError) => {
      handleErrorNotify(err, lang.label.recorder.notify.connection.fail);
    },
  });

  const onClickSave = useCallback(
    (connection: LocalConnectionInfo) => {
      mutationConnectionCreate.mutate({
        accountId: props.accountId,
        mergedSystemId: props.mergedSystemId,
        payload: connection,
      });
    },
    [mutationConnectionCreate, props.accountId, props.mergedSystemId]
  );

  const isSpectrum = (props.type || "").toUpperCase() === "SPECTRUM";

  const spectrumIsDisabled =
    isSpectrum && (!cloudStatus || !props.cloudSystemId);
  const isDisabledLinux = getClientDevice() === "Linux PC" && !isSpectrum;

  if (
    selectedAccount.accountLevel === LEVEL_TYPE.EU &&
    !selectedAccount.isHidden &&
    selectedAccount.isEnabled
  ) {
    if (props.isCovaConfigure && props.type.toUpperCase() === "COVA") {
      return (
        <UnderlineText
          onClick={(e) => {
            e.stopPropagation();
            OnClickWebLink();
          }}
          className="web-app-link"
          data-testid="blocks-link-web-link-cova"
        >
          <FaLink size={14} />
          COVA Web
        </UnderlineText>
      );
    }
    return (
      <>
        <Container
          onClick={(e) => e.stopPropagation()}
          data-testid="blocks-link-web-link-container"
        >
          {/* {isOpenSpectrumLogin && <SpectrumLogin />} */}
          {spectrumIsDisabled ? (
            <WithTooltip tooltip={"Unable to connect to local network."}>
              <span className="disabled web-app-link">Web</span>
            </WithTooltip>
          ) : (
            <UnderlineText
              fontSize={14}
              onClick={(e) => {
                e.stopPropagation();
                OnClickWebLink();
              }}
              className="web-app-link"
              data-testid="blocks-link-web-link-web"
            >
              {isRestricted ? (
                <WithTooltip showAtTop={true} tooltip={"Access restricted."}>
                  <span>Web</span>
                </WithTooltip>
              ) : (
                "Web"
              )}
            </UnderlineText>
          )}

          {(convertType(props) !== "COVA" ||
            (convertType(props) === "COVA" && (isIos || isAndroid))) && (
            <UnderlineText
              fontSize={14}
              onClick={(e) => {
                e.stopPropagation();
                if (isSpectrum && !cloudStatus) return;
                if (isDisabledLinux) return;
                OnClickAppLink();
              }}
              className="web-app-link"
              disabled={isDisabledLinux || (isSpectrum && !cloudStatus)}
              data-testid="blocks-link-web-link-app"
            >
              {isRestricted ? (
                <WithTooltip showAtTop={true} tooltip={"Access restricted."}>
                  <span>APP</span>
                </WithTooltip>
              ) : (
                "APP"
              )}
            </UnderlineText>
          )}
        </Container>
        {isOpenSpectrumLogin && (
          <ModalWrapper data-key="recorder-polling-popup">
            <SpectrumLoginConfirmModal
              onClose={onCloseWebLogin}
              onCode={onCode}
              accountId={props.accountId}
              mergedSystemId={props.mergedSystemId}
            />
          </ModalWrapper>
        )}
        {isLocalSpectrumLogin && (
          <ModalWrapper data-key="recorder-polling-popup">
            <SpectrumLogin
              onClose={onCloseLocalLogin}
              onClickSave={onClickSave}
              accountId={props.accountId}
              mergedSystemId={props.mergedSystemId}
            />
          </ModalWrapper>
        )}{" "}
        {showRestrictedPopup && (
          <SmallPopupTemplate
            title="Access Restricted"
            onClick={onToggleRestrictedPopup}
            onModal={onToggleRestrictedPopup}
            confirmLabel="OK"
            data-testid="blocks-link-link-small-popup-template-toggle-restricted-popup"
          >
            <RestrictedPopupContent>
              Only registered users can log in.
              <br />
              Your account is no longer registered on this NVR because the
              maximum number of supported users has been reached. Please contact
              your administrator to restore access.
            </RestrictedPopupContent>
          </SmallPopupTemplate>
        )}
      </>
    );
  } else {
    return <></>;
  }
}

export default WebAppLink;

const RestrictedPopupContent = styled.div`
  font-size: ${calcRem(14)};
  line-height: 1.5;
  color: ${({ theme }) => theme.COLORS.WHITE};
`;

const Container = styled.div`
  ${FLEX.FlexStartCenter};
  gap: 1px;
  .web-app-link {
    padding: 15px 4px;
    margin: -15px 0;
  }
  .disabled {
    color: ${COLORS.BUTTONS1};
    cursor: not-allowed;
    font-size: ${calcRem(14)};
    text-decoration: line-through;
  }
`;

const ModalWrapper = styled.div`
  position: absolute;
  z-index: 990;
  width: 100vw;
  height: 100vh;
`;
